import React from "react";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import jwt_decode from "jwt-decode";
import TextInput from "../../Components/TextInput/TextInput";
import call from "../../API/API";
import GooLoader from "../../Components/GooLoader/GooLoader";
import { Helmet } from "react-helmet-async";
import { withRouter } from "react-router-dom";
import "./AccountLinks.css";

class AccountLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      meeting_days: [],
      meeting_scheduler: "",
      linkedin_url: "",
      website: "",
      isLoading: true,
    };

    this.handleMeetingSchedulerOnChange = this.handleMeetingSchedulerOnChange.bind(
      this
    );
    this.handleLinkedInOnChange = this.handleLinkedInOnChange.bind(this);
    this.handleWebsiteOnChange = this.handleWebsiteOnChange.bind(this);
    this.handleFinishSetup = this.handleFinishSetup.bind(this);
    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/");
    } else {
      let decoded = jwt_decode(token);
      if (
        this.props.location.state === undefined ||
        !this.props.location.state.userData ||
        !this.props.location.state.userData.matching_criteria
      ) {
        if (!decoded.active) {
          this.props.history.push("/");
        } else {
          this.props.history.push("/dashboard");
        }
      } else {
        let userData = this.props.location.state.userData;
        if (!decoded.active) {
          this.props.history.push("/payment", { userData: userData });
        } else {
          const { meeting_days } = userData.matching_criteria;
          if (!meeting_days) {
            this.props.history.push("/matching-criteria-6", {
              userData: userData,
            });
          } else {
            this.setState({
              isLoading: false,
            });
          }
        }
      }
    }
  }

  handleFinishSetup() {
    this.setState({
      isLoading: true,
    });
    let meeting_scheduler = this.state.meeting_scheduler;
    let linkedin = this.state.linkedin_url;
    let company_website = this.state.website;
    let userData = this.props.location.state.userData;

    let matching_criteria = {
      ...userData.matching_criteria,
      account_links: {
        meeting_scheduler: meeting_scheduler,
        linkedin: linkedin,
        company_website: company_website,
      },
    };

    call.matching_criteria_API
      .createMatchingCriteria(matching_criteria)
      .then((response) => {
        if (response.success) {
          this.props.resetState();
          this.props.history.push("/dashboard");
        } else {
          this.props.history.push("/error", { error: response.results });
        }
      })
      .catch((err) => {
        this.props.history.push("/error", { error: err.message });
      });
  }

  handleMeetingSchedulerOnChange(e) {
    this.setState({
      meeting_scheduler: e.target.value,
    });
  }

  handleLinkedInOnChange(e) {
    this.setState({
      linkedin_url: e.target.value,
    });
  }

  handleWebsiteOnChange(e) {
    this.setState({
      website: e.target.value,
    });
  }

  handleBackButtonClick() {
    this.props.history.goBack();
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <GooLoader /> : null}

        <RegistrationForm
          containerClassName="container-account-links"
          hasCounter={false}
          hasQuote={false}
          headerText="Let's link up!"
          primaryButtonText="Finish setup"
          hasSkip={false}
          handlePrimaryBtnOnClick={this.handleFinishSetup}
          activatePrimaryWithEnter={true}
          showButton={true}
          showBackButton={true}
          backButtonText="Back"
          handleBackButtonClick={this.handleBackButtonClick}
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>

          <div className="form-container-body-row">
            <TextInput
              type="text"
              id="meeting-scheduler"
              value={this.state.meeting_scheduler}
              handleTextInputOnChange={this.handleMeetingSchedulerOnChange}
              label="Do you use a meeting scheduler (ie. Calendly)? If so, what's your link?"
              placeholder="Meeting scheduler link"
            />
          </div>

          <div className="form-container-body-row">
            <TextInput
              type="text"
              id="linkedin"
              value={this.state.linkedin_url}
              handleTextInputOnChange={this.handleLinkedInOnChange}
              label="What's your LinkedIn profile URL?"
              placeholder="Linkedin profile link"
            />
          </div>

          <div className="form-container-body-row">
            <TextInput
              type="text"
              id="company-website"
              value={this.state.website}
              handleTextInputOnChange={this.handleWebsiteOnChange}
              label="Do you have a company website?"
              placeholder="Company website URL"
            />
          </div>
        </RegistrationForm>
      </React.Fragment>
    );
  }
}

export default withRouter(AccountLinks);
